import { ModuleKind } from '../enums/module-kind.enum';
import { IModuleKind } from '../interfaces/module-kind.interface';

// @dynamic
export class ModuleKinds {
    static all: IModuleKind[] = [
        {
            translationLabel: 'MODULE.SINGULAR',
            value: ModuleKind.Normal,
        },
        {
            translationLabel: 'MODULE.KIND.MODULE.SINGULAR',
            value: ModuleKind.Execution,
        },
        {
            translationLabel: 'MODULE.TYPE.PROGRAM',
            value: ModuleKind.ProgramExecution,
        },
        {
            translationLabel: 'MODULE.KIND.TEMPLATE.SINGULAR',
            value: ModuleKind.Template,
        },
        {
            translationLabel: 'MODULE.KIND.PROGRAM_TEMPLATE.SINGULAR',
            value: ModuleKind.ProgramTemplate,
        },
    ];
}
